/*
 * @Author: your name
 * @Date: 2021-05-25 16:30:33
 * @LastEditTime: 2021-10-12 12:59:07
 * @LastEditors: sueRimn
 * @Description: In User Settings Edit
 * @FilePath: \app-project\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import store from '../../store'
import config from '../config'
import appCall from '../common/http/appCall'

let init = false

Vue.use(Router)

const routes = new Router({
  routes: [
    {
      path: '/',
      name: 'privacyPolicy',
      component: r => require.ensure([], () => r(require('@/views/privacyPolicy')), 'privacyPolicy')
    },
    {
      path: '/serviceTerms',
      name: 'serviceTerms',
      component: r => require.ensure([], () => r(require('@/views/serviceTerms')), 'serviceTerms')
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: r => require.ensure([], () => r(require('@/views/aboutUs')), 'aboutUs')
    },
    {
      path: '/dataStatistics',
      name: 'dataStatistics',
      component: r => require.ensure([], () => r(require('@/views/dataStatistics')), 'dataStatistics')
    },
    {
      path: '/dataStatisticsDetail',
      name: 'dataStatisticsDetail',
      component: r => require.ensure([], () => r(require('@/views/dataStatisticsDetail')), 'dataStatisticsDetail')
    },
    {
      path: '/contrabandList',
      name: 'contrabandList',
      component: r => require.ensure([], () => r(require('@/views/contrabandList')), 'contrabandList')
    },
    {
      path: '/question',
      name: 'question',
      component: r => require.ensure([], () => r(require('@/views/question')), 'question')
    },
    {
      path: '/operationProcess',
      name: 'operationProcess',
      component: r => require.ensure([], () => r(require('@/views/operationProcess')), 'operationProcess')
    },
    {
      path: '/dispatchAnalyse',
      name: 'dispatchAnalyse',
      component: r => require.ensure([], () => r(require('@/views/dispatchAnalyse')), 'dispatchAnalyse')
    },
    {
      path: '/dispatchDetail',
      name: 'dispatchDetail',
      component: r => require.ensure([], () => r(require('@/views/dispatchDetail')), 'dispatchDetail')
    },
    {
      path: '/packageDetails',
      name: 'packageDetails',
      component: r => require.ensure([], () => r(require('@/views/packageDetails')), 'packageDetails')
    },
    {
      path: '/empty',
      name: 'empty',
      component: r => require.ensure([], () => r(require('@/views/packageDetails/empty.vue')), 'empty')
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: r => require.ensure([], () => r(require('@/views/protocol.vue')), 'protocol')
    },
    {
      path: '/checkIdCard',
      name: 'checkIdCard',
      component: r => require.ensure([], () => r(require('@/views/checkIdCard.vue')), 'checkIdCard')
    },
    {
      path: '/handOverCOD',
      name: 'handOverCOD',
      component: r => require.ensure([], () => r(require('@/views/handOverCOD')), 'handOverCOD')
    },
    {
      path: '/systemSwitch',
      name: 'systemSwitch',
      component: r => require.ensure([], () => r(require('@/views/systemSwitch')), 'systemSwitch')
    }
  ]
})

routes.beforeEach((form, to, next) => {
  if (config.authSkipRoutes.indexOf(form.name) !== -1) {
    next()
  } else {
    if (init === false) {
      init = true
      // 如果需要用开发模式跟APP联调 需要改成 ===
      if (process.env.NODE_ENV !== 'development') {
        if (form.query.source === '1') {
          store.commit('updateSystem', 'IOS')
          store.commit('updateConsultativeCode', 'XYBM00001')
          next()
        } else {
          appCall().then(res => {
            next()
          })
        }
      } else {
        store.commit('updateSystem', 'IOS')
        store.commit('updateConsultativeCode', 'XYBM00001')
        // store.commit('updateToken', 'eyJhbGciOiJIUzUxMiJ9.eyJzeXNDb2RlIjoiQVBQIiwic2Vzc2lvbklEIjoiYTQyMGI4ZGZjZjM3NGE1Njk1ZDFlOTc5N2JkNzczNjQiLCJleHAiOjE2MzI0NjExNzYsImlhdCI6MTYyOTg2OTE3NiwidXBzVXNlciI6IntcImlkXCI6MjEwLFwiaXNEZWxldGVcIjoxLFwibW9iaWxlXCI6XCIxNTkzNzE2ODMwXCIsXCJuYW1lXCI6XCI4MzBcIixcInN0YWZmU3RhdGVcIjowLFwic3RhZmZUeXBlXCI6MCxcInN0YXRpb25Db2RlXCI6XCJUSDAwMDMzN1wiLFwic3RhdGlvbk5hbWVcIjpcIum-memXqOmpv-ermVwiLFwic3lzQ29kZVwiOlwiQVBQXCJ9In0.zrPyEGk9Ir8NBruotu7zVZmmZeeINYQJWvR1xLtrisaHU0E4gk9iB-CinQ-wNDBpxX72Z-PIRG1intGhj8YnEQ')
        // store.commit('updateToken', 'eyJhbGciOiJIUzUxMiJ9.eyJzeXNDb2RlIjoiQVBQIiwic2Vzc2lvbklEIjoiYzA1ZGEzM2UwMDY4NDFiNTliMDM0YWI4NzM0NmU5ZTQiLCJleHAiOjE2MzMyMzA0NzMsImlhdCI6MTYzMDYzODQ3MywidXBzVXNlciI6IntcImlkXCI6NDksXCJpc0RlbGV0ZVwiOjEsXCJtb2JpbGVcIjpcIjAwMDAzNDA5ODJcIixcIm5hbWVcIjpcIkF1dG9UZXN0X0xpbmluZ1wiLFwic3RhZmZTdGF0ZVwiOjAsXCJzdGFmZlR5cGVcIjowLFwic3RhdGlvbkNvZGVcIjpcIlRIMDAwMDEyXCIsXCJzdGF0aW9uTmFtZVwiOlwiVEhfU0lUX0F1dG9UZXN0X0xpbmluZ1wiLFwic3lzQ29kZVwiOlwiQVBQXCJ9In0.7IMWtrNwXrVtxo-4N8pPJHls05BVa36wlBXMnoXPSiZgFwJbV_P5VfLqeYK2Tx3l7Q2kMs0N_EyxSG7tQoNnYA')
        // store.commit('updateStationCode', '499')
        next()
      }
    } else {
      next()
    }
  }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js